<template>
  <FancyDialog :isPadding="false" v-bind="{ ...$attrs }" v-on="$listeners">
    <v-container fluid class="dialog_container">
      <!-- <img
                width="90"
                height="90"
                class="mb-1"
                src="@/assets/images/imgTick.svg"
                alt=""
            /> -->
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 28px;
          align-items: start;
          padding: 0 16px;
          text-align: start;
        "
      >
        <p class="large-title2-semibold" style="color: #ff9f4b">領取成功</p>
        <p class="body-regular" style="color: #0d0c0c">
          已成功領取{{ sub }}，您可到「優惠票券-可使用」中查看使用
        </p>
      </div>
      <!-- <p class="title mb-3">已成功領取{{ sub }}，您可到「優惠票券-可使用」中查看使用</p> -->
      <div class="footer d-flex justify-center">
        <button
          class="sure_btn"
          @click="togglePopup"
          style="border-radius: 18px; align-content: center; cursor: pointer"
        >
          確定
          <img src="@/assets/images/white-foot.png" style="width: 24px; height: 24px" />
        </button>
        <!-- <FancyButton isGreen class="btn mr-3" label="確定" @click="togglePopup" /> -->
      </div>
    </v-container>
  </FancyDialog>
</template>

<script>
import FancyDialog from '@/components/FancyDialog.vue'
// import FancyButton from '@/components/FancyButton.vue'
// import Button from '@/components/Atom/Button.vue'
export default {
  components: {
    FancyDialog,
    // FancyButton,
    // Button,
  },
  name: 'PopupPointCouponExchange',
  props: {
    sub: {
      type: String,
    },
    togglePopup: {
      type: Function,
    },
  },
  emits: ['input', 'click:confirm'],
  data: () => ({}),
}
</script>

<style lang="scss" scoped>
.sure_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff9f4b;
  color: #fff;
  gap: 10px;
  border-radius: 18px;
  padding: 16px;
  width: 100%;
  &:active {
    background-color: #d16200;
  }
}
div.dialog_container {
  position: relative;
  z-index: 1;
  padding: 32px 16px 24px 16px;
  p.title {
    color: $color_main_first;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: -0.3px;
  }
  p.desc {
    font-size: 14px;
    line-height: 24px;
    color: $color_main_black;
  }
  > .footer {
    .btn {
      height: 50px;
      width: 100%;
      @media screen and (max-width: 374px) {
        max-width: 118px;
      }
      @media screen and (min-width: 375px) {
        max-width: 145.5px;
      }
    }
  }
}
</style>
